import React from 'react';
import Analytics from './Analytics';

export function TopNavAnalytics() {
  return <Analytics />;
}

export default TopNavAnalytics;